import React from 'react';
import {
	CreateButton,
	useListContext,
	sanitizeListRestProps,
	TopToolbar,
	usePermissions
} from 'react-admin';
import { DataExport } from '../../../components/dialogs/DataExportDialog';
import { isInArray } from '../../../utils/general';
import { AppRoles } from '../../../entities';

export const CustomerEmployeesActions = (props) => {
    const { className, exporter, filters, ...rest } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext(props);
	const { permissions } = usePermissions();
    const isAccessToExport = permissions && (isInArray(AppRoles, permissions.role));
    const data = "customer-employees"
    const sort = [currentSort.field, currentSort.order]
    return React.useMemo(
        () => (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                {filters &&
                    React.cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: 'button',
                    })}               
                {isAccessToExport && (<DataExport filters={filterValues} sort={sort} data={data}/>)}
                {hasCreate && <CreateButton basePath={basePath} />}
            </TopToolbar>
        ),
        [resource, displayedFilters, filterValues, selectedIds, filters, total] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
